// Test IDs pour la coquille applicative : sidebar, header, filtres globaux.
export const SIDEBAR = {
  container: 'sidebar-container',
  navDashboard: 'sidebar-nav-dashboard',
  navFindings: 'sidebar-nav-findings',
  navActions: 'sidebar-nav-actions',
  navCcv: 'sidebar-nav-ccv',
  navPced: 'sidebar-nav-pced',
  navIndicateurs: 'sidebar-nav-indicateurs',
  navClassements: 'sidebar-nav-classements',
  navScoreBog: 'sidebar-nav-score-bog',
  navAccidents: 'sidebar-nav-accidents',
  collapseToggle: 'sidebar-collapse-toggle',
};

export const HEADER = {
  container: 'header-container',
  refreshButton: 'header-refresh-button',
  userMenuTrigger: 'header-user-menu-trigger',
  logoutButton: 'header-logout-button',
};

export const FILTERS = {
  container: 'global-filters-container',
  siteSelect: 'filter-site-select',
  personSelect: 'filter-person-select',
  yearSelect: 'filter-year-select',
  monthSelect: 'filter-month-select',
  quarterSelect: 'filter-quarter-select',
  saveFavoriteButton: 'filter-save-favorite-button',
};
